export const enum routeConstants {
    bulkInsertRoutesRequest = "BULK_INSERT_ROUTES_REQUEST",
    bulkInsertRoutesSuccess = "BULK_INSERT_ROUTES_SUCCESS",
    bulkInsertRoutesFailure = "BULK_INSERT_ROUTES_FAILURE",

    updateRoutesRequest = "UPDATE_ROUTES_REQUEST",
    updateRoutesSuccess = "UPDATE_ROUTES_SUCCESS",
    updateRoutesFailure = "UPDATE_ROUTES_FAILURE",
}
